/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchLoadWishListIfNeeded,
} from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListIfNeeded";

import loadWishList from "@insite/client-framework/Store/Data/WishLists/Handlers/LoadWishList";
import { getWishListState } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";

export const XngDispatchLoadWishListIfNeeded: any = (props: any) => {
    const wishListState = getWishListState(props.getState(), props.parameter.wishListId);
    const expandParams = ["schedule", "sharedUsers", "getbadges", "getstyledchildrencount", "properties", "favorite", "hidden", "tags"];
    if (
        !wishListState.value ||
        wishListState.value.schedule === undefined ||
        !wishListState.value.sendDayOfMonthPossibleValues ||
        !wishListState.value.sendDayOfWeekPossibleValues ||
        wishListState.value.sendDayOfMonthPossibleValues.length < 1 ||
        wishListState.value.sendDayOfWeekPossibleValues.length < 1 ||
        wishListState.value.wishListTags === null
    ) {
        props.dispatch(
            loadWishList({
                wishListId: props.parameter.wishListId,
                exclude: ["listLines"],
                expand: expandParams as any,
            }),
        );
    }
};

replaceInChain(chain, DispatchLoadWishListIfNeeded, XngDispatchLoadWishListIfNeeded);
